import React from "react";
import styled from "styled-components";
import { useLoyalty, useTheme } from "../../hooks/";
import { StyledText } from "../../components/common/basic";
import { useHistory } from "react-router-dom";
import OfferCards from "../loyalty/offerCards";

const LoyaltyView = () => {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const history = useHistory();

  const {
    loyaltyOffersData,
    promoOffersData,
    setOfferModal,
    setSelectedLoyaltyData,
    redemptionVendorData,
  } = useLoyalty();

  return (
    <>
      <OfferHeader>
        <StyledText style={{ fontSize: "18px", fontWeight: "bold" }}>
          Loyalty
        </StyledText>

        <ViewAllHolder onClick={() => history.push(`/loyalty/blackFriday`)}>
          <StyledText
            style={{
              fontSize: "14px",
              fontFamily: "MTNRegular",
              margin: "1px 0 0 0",
            }}
            color={background}
          >
            View all
          </StyledText>
        </ViewAllHolder>
      </OfferHeader>
      <div
        style={{
          display: "grid",
          gap: "0px",
          grid: "auto / 50% 50%",
          maxWidth: "370px",
          margin: "0 auto",
        }}
      >
        {loyaltyOffersData && promoOffersData && (
          <OfferCards
            cardMargin="10px auto"
            offers={[...loyaltyOffersData, ...redemptionVendorData]}
            setData={setSelectedLoyaltyData}
            setModal={setOfferModal}
            history={history}
          />
        )}
      </div>
    </>
  );
};

export default LoyaltyView;

const OfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 20px;
`;

const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;
